import React, {useEffect} from 'react';
import {useNavigate} from 'react-router';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {AppAnon} from 'app/AppAnon';
import {useCallbackParams} from './hooks/useCallbackParams';

type Props = NoProps;

export const LoginCallback: React.FC<Props> = () => {
  const {code, error, state} = useCallbackParams();
  const navigate = useNavigate();
  const {t} = useLocalization();

  useEffect(() => {
    if (code) {
      if (state) {
        navigate(state.redirect);
      } else {
        navigate('/');
      }
    } else {
      console.error('LoginCallback error:', error);
      navigate('/login');
    }
  }, [code, error, navigate, state]);

  return <AppAnon>{t('page.login.redirect')}</AppAnon>;
};
